import { ButtonHighlight, Icon } from "@france/superelements/lib";
import { useLocalize } from "@france/superelements/utils";
import { IonModal } from "@ionic/react";
import "./ChoiceModal.scss";

interface ChoiceModalProps {
  id?: string;
  isOpen: boolean;
  title?: string;
  description?: string;
  firstLabel?: string;
  secondLabel?: string;
  onFirst: () => void;
  onSecond: () => void;
  onClose: () => void;
}

const ChoiceModal: React.FC<ChoiceModalProps> = ({
  id = "ChoiceModal",
  isOpen,
  title,
  description,
  firstLabel,
  secondLabel,
  onFirst,
  onSecond,
  onClose,
}) => {
  const t = useLocalize();

  return (
    <IonModal id={id} onWillDismiss={onClose} isOpen={isOpen}>
      <div className="container">
        <div className="header">
          <div className="title">{title}</div>
          <Icon icon="x" onClick={onClose} />
        </div>
        {!!description && (
          <div className="content">
            <div className="description">{description}</div>
          </div>
        )}
        <div className="footer">
          <ButtonHighlight
            name={firstLabel || t("cancel")}
            type="secondary"
            onClick={onFirst}
          />
          <ButtonHighlight
            name={secondLabel || t("delete")}
            onClick={onSecond}
          />
        </div>
      </div>
    </IonModal>
  );
};

export default ChoiceModal;
